module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=MO - Macau.1c27f6ad.svg";